const da = new Intl.NumberFormat("da-DK");
const da2 = new Intl.NumberFormat("da-DK", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

/** Whole number, da-DK grouping (e.g. 7.799). */
export const n = (x: number) => da.format(Math.round(x));

/** Two decimals, da-DK (e.g. 2,06). */
export const n2 = (x: number) => da2.format(x);
